webpackJsonp([1],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "db", function() { return db; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "globalStore", function() { return globalStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filters__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_App_vue__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase_app__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_firebase_firestore__ = __webpack_require__(135);

















__WEBPACK_IMPORTED_MODULE_9_firebase_app___default.a.initializeApp({
  apiKey: "AIzaSyA1uEocB09ou9W9l02ha8MS3X7JLZTtO4s",
  authDomain: "gusec-application-status.firebaseapp.com",
  databaseURL: "https://gusec-application-status.firebaseio.com",
  projectId: "gusec-application-status",
  storageBucket: "gusec-application-status.appspot.com",
  messagingSenderId: "972099078718"
});

var db = __WEBPACK_IMPORTED_MODULE_9_firebase_app___default.a.firestore();

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter("count", __WEBPACK_IMPORTED_MODULE_7__filters__["a" /* count */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter("domain", __WEBPACK_IMPORTED_MODULE_7__filters__["b" /* domain */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter("prettyDate", __WEBPACK_IMPORTED_MODULE_7__filters__["c" /* prettyDate */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter("pluralize", __WEBPACK_IMPORTED_MODULE_7__filters__["d" /* pluralize */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter("formatDate", function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_3_moment___default()(String(value)).format("DD MMM YYYY | HH:mm");
  }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter("Birthdate", function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_3_moment___default()(String(value)).format("DD-MMM-YYYY");
  }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter("formatDate2", function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_3_moment___default()(String(value)).format("DD MMM YYYY");
  }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_5__routes__["a" /* default */],

  linkExactActiveClass: "active",
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  }) && (!router.app.$store.state.token || router.app.$store.state.token === "null")) {
    window.console.log("Not authenticated");
    next({
      path: "/login",
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */], router);

if (window.localStorage) {
  var localUserString = window.localStorage.getItem("user") || "null";
  var localUser = JSON.parse(localUserString);

  if (localUser && __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].state.user !== localUser) {
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit("SET_USER", localUser);
    __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */].commit("SET_TOKEN", window.localStorage.getItem("token"));
  }
}

var globalStore = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  data: {
    AdminId: '',
    AdminInfo: '',
    PricePlan: '',
    CompanyName: '',
    CompanyWebsite: ''
  }
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: "#root",
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_8__components_App_vue___default.a);
  }
});

window.bugsnagClient = window.bugsnag("02fe1c2caaf5874c50b6ee19534f5932");
window.bugsnagClient.use(window.bugsnag__vue(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]));

/***/ }),

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = domain;
/* harmony export (immutable) */ __webpack_exports__["a"] = count;
/* harmony export (immutable) */ __webpack_exports__["c"] = prettyDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = pluralize;
var urlParser = document.createElement('a');

function domain(url) {
  urlParser.href = url;
  return urlParser.hostname;
}

function count(arr) {
  return arr.length;
}

function prettyDate(date) {
  var a = new Date(date);
  return a.toDateString();
}

function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }

  return time + label + 's';
}

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_404_vue__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_404_vue__);



var routes = [{
  path: "/",
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default.a
}, {
  path: "*",
  component: __WEBPACK_IMPORTED_MODULE_1__components_404_vue___default.a
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(145);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */]
}));

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(148)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(157),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotFound'
});

/***/ }),

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App'
});

/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(10);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'HelloWorld',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      applications: [],
      mobile: "",
      email: "",
      fname: "",
      lname: "",
      status: "",
      show: false,
      showButton: false,
      showStatus: true,
      submitLoader: false,
      showNotFound: false,
      statusMessage: "",
      showTable: false,
      array: []
    };
  },
  mounted: function mounted() {
    console.log("Component Mounted");
  },

  methods: {
    GetData: function GetData() {
      var _this = this;

      console.log("Get Data");

      __WEBPACK_IMPORTED_MODULE_0__main__["db"].collection('application-status').get().then(function (snap) {
        var testCollection = [];
        snap.forEach(function (doc) {
          testCollection.push(doc.data());
        });
        _this.applications = testCollection;
        console.log("Total Applications: " + _this.applications.length);
      });
    },
    onChange: function onChange() {
      console.log(this.mobile.length);
      if (this.mobile.length == 10) {
        this.show = true;
      } else {
        this.show = false;
      }
    },
    showB: function showB() {
      console.log(this.mobile.length);
      if (this.email.length > 8) {
        this.showButton = true;
      } else {
        this.showButton = false;
      }
    },
    checkStatus: function checkStatus() {
      var _this2 = this;

      this.showNotFound = false;
      this.showStatus = false;

      this.submitLoader = true;

      console.log("Checking Status...");
      console.log("Mobile: " + this.mobile);
      console.log("Email: " + this.email);

      __WEBPACK_IMPORTED_MODULE_0__main__["db"].collection('application-status').where("mobile", "==", this.mobile).where("email", "==", this.email).get().then(function (doc) {

        var length = doc.docs.length;
        console.log("Length: " + length);

        _this2.submitLoader = false;

        if (length > 1) {
          _this2.showTable = true;
        }

        if (length > 0) {

          _this2.showStatus = true;

          var i = 0;

          doc.docs.forEach(function (info) {

            console.log(info.id);
            console.log(info.data());
            console.log(info.data().fname);
            console.log(info.data().lname);
            console.log(info.data().mobile);
            console.log(info.data().startup);

            _this2.fname = info.data().fname;
            _this2.lname = info.data().lname;
            _this2.mobile = info.data().mobile;
            _this2.email = info.data().email;
            _this2.status = info.data().status;

            var info = {
              fname: info.data().fname,
              lname: info.data().lname,
              mobile: info.data().mobile,
              email: info.data().email,
              status: info.data().status,
              startup: info.data().startup,
              reason: info.data().reason
            };

            _this2.array.push(info);
          });
        } else {

          console.log("Not Found");
          _this2.showNotFound = true;
        }
      }).catch(function (err) {
        console.log(err);

        console.log("Record Not Found");
      });
    }
  }
});

/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  callingAPI: false,
  searching: '',
  serverURI: 'http://10.110.1.136:8080',
  user: null,
  token: null,
  userInfo: {
    messages: [{ 1: 'test', 2: 'test' }],
    notifications: [],
    tasks: []
  }
});

/***/ }),

/***/ 148:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 149:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 150:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 11,
	"./af.js": 11,
	"./ar": 18,
	"./ar-dz": 12,
	"./ar-dz.js": 12,
	"./ar-kw": 13,
	"./ar-kw.js": 13,
	"./ar-ly": 14,
	"./ar-ly.js": 14,
	"./ar-ma": 15,
	"./ar-ma.js": 15,
	"./ar-sa": 16,
	"./ar-sa.js": 16,
	"./ar-tn": 17,
	"./ar-tn.js": 17,
	"./ar.js": 18,
	"./az": 19,
	"./az.js": 19,
	"./be": 20,
	"./be.js": 20,
	"./bg": 21,
	"./bg.js": 21,
	"./bm": 22,
	"./bm.js": 22,
	"./bn": 23,
	"./bn.js": 23,
	"./bo": 24,
	"./bo.js": 24,
	"./br": 25,
	"./br.js": 25,
	"./bs": 26,
	"./bs.js": 26,
	"./ca": 27,
	"./ca.js": 27,
	"./cs": 28,
	"./cs.js": 28,
	"./cv": 29,
	"./cv.js": 29,
	"./cy": 30,
	"./cy.js": 30,
	"./da": 31,
	"./da.js": 31,
	"./de": 34,
	"./de-at": 32,
	"./de-at.js": 32,
	"./de-ch": 33,
	"./de-ch.js": 33,
	"./de.js": 34,
	"./dv": 35,
	"./dv.js": 35,
	"./el": 36,
	"./el.js": 36,
	"./en-au": 37,
	"./en-au.js": 37,
	"./en-ca": 38,
	"./en-ca.js": 38,
	"./en-gb": 39,
	"./en-gb.js": 39,
	"./en-ie": 40,
	"./en-ie.js": 40,
	"./en-nz": 41,
	"./en-nz.js": 41,
	"./eo": 42,
	"./eo.js": 42,
	"./es": 45,
	"./es-do": 43,
	"./es-do.js": 43,
	"./es-us": 44,
	"./es-us.js": 44,
	"./es.js": 45,
	"./et": 46,
	"./et.js": 46,
	"./eu": 47,
	"./eu.js": 47,
	"./fa": 48,
	"./fa.js": 48,
	"./fi": 49,
	"./fi.js": 49,
	"./fo": 50,
	"./fo.js": 50,
	"./fr": 53,
	"./fr-ca": 51,
	"./fr-ca.js": 51,
	"./fr-ch": 52,
	"./fr-ch.js": 52,
	"./fr.js": 53,
	"./fy": 54,
	"./fy.js": 54,
	"./gd": 55,
	"./gd.js": 55,
	"./gl": 56,
	"./gl.js": 56,
	"./gom-latn": 57,
	"./gom-latn.js": 57,
	"./gu": 58,
	"./gu.js": 58,
	"./he": 59,
	"./he.js": 59,
	"./hi": 60,
	"./hi.js": 60,
	"./hr": 61,
	"./hr.js": 61,
	"./hu": 62,
	"./hu.js": 62,
	"./hy-am": 63,
	"./hy-am.js": 63,
	"./id": 64,
	"./id.js": 64,
	"./is": 65,
	"./is.js": 65,
	"./it": 66,
	"./it.js": 66,
	"./ja": 67,
	"./ja.js": 67,
	"./jv": 68,
	"./jv.js": 68,
	"./ka": 69,
	"./ka.js": 69,
	"./kk": 70,
	"./kk.js": 70,
	"./km": 71,
	"./km.js": 71,
	"./kn": 72,
	"./kn.js": 72,
	"./ko": 73,
	"./ko.js": 73,
	"./ky": 74,
	"./ky.js": 74,
	"./lb": 75,
	"./lb.js": 75,
	"./lo": 76,
	"./lo.js": 76,
	"./lt": 77,
	"./lt.js": 77,
	"./lv": 78,
	"./lv.js": 78,
	"./me": 79,
	"./me.js": 79,
	"./mi": 80,
	"./mi.js": 80,
	"./mk": 81,
	"./mk.js": 81,
	"./ml": 82,
	"./ml.js": 82,
	"./mr": 83,
	"./mr.js": 83,
	"./ms": 85,
	"./ms-my": 84,
	"./ms-my.js": 84,
	"./ms.js": 85,
	"./mt": 86,
	"./mt.js": 86,
	"./my": 87,
	"./my.js": 87,
	"./nb": 88,
	"./nb.js": 88,
	"./ne": 89,
	"./ne.js": 89,
	"./nl": 91,
	"./nl-be": 90,
	"./nl-be.js": 90,
	"./nl.js": 91,
	"./nn": 92,
	"./nn.js": 92,
	"./pa-in": 93,
	"./pa-in.js": 93,
	"./pl": 94,
	"./pl.js": 94,
	"./pt": 96,
	"./pt-br": 95,
	"./pt-br.js": 95,
	"./pt.js": 96,
	"./ro": 97,
	"./ro.js": 97,
	"./ru": 98,
	"./ru.js": 98,
	"./sd": 99,
	"./sd.js": 99,
	"./se": 100,
	"./se.js": 100,
	"./si": 101,
	"./si.js": 101,
	"./sk": 102,
	"./sk.js": 102,
	"./sl": 103,
	"./sl.js": 103,
	"./sq": 104,
	"./sq.js": 104,
	"./sr": 106,
	"./sr-cyrl": 105,
	"./sr-cyrl.js": 105,
	"./sr.js": 106,
	"./ss": 107,
	"./ss.js": 107,
	"./sv": 108,
	"./sv.js": 108,
	"./sw": 109,
	"./sw.js": 109,
	"./ta": 110,
	"./ta.js": 110,
	"./te": 111,
	"./te.js": 111,
	"./tet": 112,
	"./tet.js": 112,
	"./th": 113,
	"./th.js": 113,
	"./tl-ph": 114,
	"./tl-ph.js": 114,
	"./tlh": 115,
	"./tlh.js": 115,
	"./tr": 116,
	"./tr.js": 116,
	"./tzl": 117,
	"./tzl.js": 117,
	"./tzm": 119,
	"./tzm-latn": 118,
	"./tzm-latn.js": 118,
	"./tzm.js": 119,
	"./uk": 120,
	"./uk.js": 120,
	"./ur": 121,
	"./ur.js": 121,
	"./uz": 123,
	"./uz-latn": 122,
	"./uz-latn.js": 122,
	"./uz.js": 123,
	"./vi": 124,
	"./vi.js": 124,
	"./x-pseudo": 125,
	"./x-pseudo.js": 125,
	"./yo": 126,
	"./yo.js": 126,
	"./zh-cn": 127,
	"./zh-cn.js": 127,
	"./zh-hk": 128,
	"./zh-hk.js": 128,
	"./zh-tw": 129,
	"./zh-tw.js": 129
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;

/***/ }),

/***/ 154:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(149)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(158),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(150)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(159),
  /* scopeId */
  "data-v-e8a21100",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "15em"
    },
    attrs: {
      "src": __webpack_require__(154)
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 158:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notFound"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logo-new.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('h1', [_vm._v("Oops,")]), _vm._v(" "), _c('h4', [_vm._v("This page doesn't exist.")]), _vm._v(" "), _c('router-link', {
    staticClass: "vertical-5p lead",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Take me home.")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 159:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('p', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v("Startup Application Tracking")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.checkStatus($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "placeholder": "10 Digit Mobile",
      "id": "mobile",
      "required": "",
      "minlength": "10",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "keyup": function($event) {
        _vm.onChange()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.show == true) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email Address",
      "id": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        _vm.showB()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showButton == true) ? _c('input', {
    staticClass: "btn btn-primary btn-block button",
    attrs: {
      "type": "submit",
      "value": "Check Status"
    }
  }) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.submitLoader) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin",
    staticStyle: {
      "font-size": "24px"
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showStatus == true && _vm.showTable == true) ? _c('table', {
    staticClass: "table .table-bordered .table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.array), function(val, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.startup))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.fname) + " " + _vm._s(val.lname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.mobile))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(val.reason))]), _vm._v(" "), _c('td', [(val.status == 'Selected') ? _c('p', [_vm._v("\n                      Congratulations! You will receive an email with further details.\n                    ")]) : _vm._e(), _vm._v(" "), (val.status == 'Shortlisted') ? _c('p', [_vm._v("\n                      Congratulations! Your application is shortlisted and you will receive an email with further details for the next round of scrutiny if you have not received already.\n                    ")]) : _vm._e(), _vm._v(" "), (val.status == 'Under Review') ? _c('p', [_vm._v("\n                      It usually takes up to 30-45 working days\n                      to review your application. Please allow\n                      adequate time for review and check back later\n                      for an updated status on your application.\n                    ")]) : _vm._e(), _vm._v(" "), (val.status == 'Decision Taken') ? _c('p', [_vm._v("\n                      A decision on your application has been taken\n                      and conveyed to you, either in person,\n                      or through an email.\n                    ")]) : _vm._e(), _vm._v(" "), (val.status == 'Not Selected') ? _c('p', [_vm._v("\n                      Your application was reviewed by a competent authority and was not found suitable for startup support at GUSEC. Due to the large volume of applications, we are unable to provide individual feedback on all applications via this platform. However, you are free to get in touch with us if you wish to get clarification on this decision taken on your application. You are also most welcome to apply for a different or an updated version of your idea using the Apply button on the GUSEC website.\n                    ")]) : _vm._e()])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.showNotFound == true) ? _c('p', [_vm._v("\n              Sorry, record not found."), _c('br'), _c('br'), _vm._v("\n\n              Are you entering the right phone number and the"), _c('br'), _vm._v("\n              email address that you submitted at the time of"), _c('br'), _vm._v("\n              application at GUSEC?"), _c('br'), _c('br'), _vm._v("\n\n              If not, application tracking will not work."), _c('br'), _vm._v("\n              Furthermore, please note it may take up to"), _c('br'), _vm._v("\n              3 working days after your submitting an application"), _c('br'), _vm._v("\n              for our application tracking system to work."), _c('br')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.array), function(val) {
    return (_vm.showTable == false) ? [(_vm.showStatus == true) ? _c('h3', [_vm._v(_vm._s(val.fname) + " " + _vm._s(val.lname))]) : _vm._e(), _vm._v(" "), (_vm.showStatus == true && val.status == 'Selected') ? _c('p', [_vm._v("\n              Application Status: " + _vm._s(val.status)), _c('br'), _c('br'), _vm._v("\n              Congratulations! You will receive an email with further details.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showStatus == true && val.status == 'Shortlisted') ? _c('p', [_vm._v("\n              Application Status: " + _vm._s(val.status)), _c('br'), _c('br'), _vm._v("\n              Congratulations!"), _c('br'), _vm._v("\n              Your application is shortlisted and you will"), _c('br'), _vm._v("\n              receive an email with further details for the"), _c('br'), _vm._v("\n              next round of scrutiny if you have not received already.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showStatus == true && val.status == 'Under Review') ? _c('p', [_vm._v("\n              Application Status: " + _vm._s(val.status)), _c('br'), _c('br'), _vm._v("\n              It usually takes up to 30-45 working days "), _c('br'), _vm._v("\n              to review your application. Please allow "), _c('br'), _vm._v("\n              adequate time for review and check back later"), _c('br'), _vm._v("\n              for an updated status on your application.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showStatus == true && val.status == 'Decision Taken') ? _c('p', [_vm._v("\n              Application Status: " + _vm._s(val.status)), _c('br'), _c('br'), _vm._v("\n              A decision on your application has been taken"), _c('br'), _vm._v("\n              and conveyed to you, either in person,"), _c('br'), _vm._v("\n              or through an email.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showStatus == true && val.status == 'Not Selected') ? _c('p', [_vm._v("\n              Application Status: " + _vm._s(val.status) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showStatus == true && val.status == 'Not Selected' && val.reason) ? _c('p', [_vm._v("\n              Reason: " + _vm._s(val.reason) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showStatus == true && val.status == 'Not Selected') ? _c('p', [_vm._v("\n              Your application was reviewed by a competent "), _c('br'), _vm._v("\n              authority and was not found suitable for startup"), _c('br'), _vm._v("\n              support at GUSEC."), _c('br'), _vm._v("\n              Due to the large volume of applications, we are unable"), _c('br'), _vm._v("\n              to provide individual feedback on all applications "), _c('br'), _vm._v("\n              via this platform. "), _c('br'), _vm._v("\n              However, you are free to get in touch with us if you wish"), _c('br'), _vm._v("\n              to get clarification on this decision taken on your application."), _c('br'), _vm._v("\n              You are also most welcome to apply for a different or an"), _c('br'), _vm._v("\n              updated version of your idea using the Apply button on the GUSEC website.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showNotFound == true) ? _c('p', [_vm._v("\n              Sorry, record not found."), _c('br'), _c('br'), _vm._v("\n\n              Are you entering the right phone number and the"), _c('br'), _vm._v("\n              email address that you submitted at the time of"), _c('br'), _vm._v("\n              application at GUSEC?"), _c('br'), _c('br'), _vm._v("\n\n              If not, application tracking will not work."), _c('br'), _vm._v("\n              Furthermore, please note it may take up to"), _c('br'), _vm._v("\n              3 working days after your submitting an application"), _c('br'), _vm._v("\n              for our application tracking system to work."), _c('br')]) : _vm._e()] : _vm._e()
  }), _vm._v(" "), _c('br')], 2)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Startup")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Reason")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Comments")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-md-auto"
  }, [_c('p', {
    attrs: {
      "id": "message"
    }
  }, [_c('b', [_vm._v("Note:")]), _vm._v(" This application tracking system is only for applications made for startup support (incubation) using the application page at "), _c('a', {
    attrs: {
      "href": "https://gusec.edu.in/apply",
      "target": "_blank"
    }
  }, [_vm._v("https://gusec.edu.in/apply")]), _vm._v(". If you have applied for accelerateBHARAT, CIF, herSTART, STARTfest or any other such program of GUSEC, application tracking will not work for those applications. For any queries, please write to us at contact@gusec.edu.in.\n              ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://gusec.edu.in/",
      "target": "_blank"
    }
  }, [_vm._v("GUSEC Website ")]), _vm._v("| "), _c('a', {
    attrs: {
      "href": "https://gusec.edu.in/apply/",
      "target": "_blank"
    }
  }, [_vm._v("Apply for Startup at GUSEC")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Powered By:"), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.easilydone.in/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "2.5em"
    },
    attrs: {
      "id": "image",
      "src": "/static/img/easilydone.png"
    }
  })])])
}]}

/***/ }),

/***/ 163:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[10]);


// WEBPACK FOOTER //
// static/js/app.e31fb150971921b06871.js